import React, { FC } from 'react';
import ReactPaginate from 'react-paginate';
import { ReactComponent as ArrowLeft } from '../../../../../icons/chevron-left.svg';
import { ReactComponent as ArrowRight } from '../../../../../icons/chevron-right.svg';
import { ReactComponent as ThreeDots } from '../../../../../icons/three-dots.svg';
import * as StyledPagination from './pagination.styles';

interface Props {
	numberOfGroups: number;
	onChange: (value: number) => void;
	marginPagesDisplayed?: number;
	pageRangeDisplayed?: number;
}

const Pagination: FC<Props> = ({ numberOfGroups, onChange, marginPagesDisplayed, pageRangeDisplayed }) => {
	return (
		<StyledPagination.PaginationContainer>
			<ReactPaginate
				previousLabel={<ArrowLeft />}
				nextLabel={<ArrowRight />}
				breakLabel={<ThreeDots />}
				breakClassName="break-me"
				pageCount={numberOfGroups}
				marginPagesDisplayed={marginPagesDisplayed || 2}
				pageRangeDisplayed={pageRangeDisplayed || 5}
				onPageChange={val => onChange(val.selected)}
				containerClassName="pagination"
				activeClassName="active"
			/>
		</StyledPagination.PaginationContainer>
	);
};

export default Pagination;
